"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchClientsQuery = exports.fetchClientQuery = exports.deleteClientMutation = exports.updateClientMutation = exports.createClientMutation = exports.clientFragment = void 0;
const tslib_1 = require("tslib");
const Client_graphql_1 = tslib_1.__importDefault(require("./fragments/Client.graphql"));
exports.clientFragment = Client_graphql_1.default;
const createClient_graphql_1 = tslib_1.__importDefault(require("./mutations/createClient.graphql"));
exports.createClientMutation = createClient_graphql_1.default;
const updateClient_graphql_1 = tslib_1.__importDefault(require("./mutations/updateClient.graphql"));
exports.updateClientMutation = updateClient_graphql_1.default;
const deleteClient_graphql_1 = tslib_1.__importDefault(require("./mutations/deleteClient.graphql"));
exports.deleteClientMutation = deleteClient_graphql_1.default;
const fetchClient_graphql_1 = tslib_1.__importDefault(require("./queries/fetchClient.graphql"));
exports.fetchClientQuery = fetchClient_graphql_1.default;
const fetchClients_graphql_1 = tslib_1.__importDefault(require("./queries/fetchClients.graphql"));
exports.fetchClientsQuery = fetchClients_graphql_1.default;
//# sourceMappingURL=index.js.map